import React, { useState, memo, useEffect } from "react";
import { Col, Row } from "reactstrap";
import "./CampClassificationPdf.css";
import { Config } from "../../../../Utils/Config";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowUp from "@mui/icons-material/ArrowUpward";
import ArrowDown from "@mui/icons-material/ArrowDownward";
import { Table, TableBody, TableHead, TableRow, TableCell } from "@mui/material";
import InfiniteScroll from "react-infinite-scroller";
import { capitalizeFirstLetter } from "../../../../helpers/dataHelper";

const campClassificationList = [
  'classification', 'address', 'proximity', 'website'
];
const CampClassificationPdf = memo((props) => {

  const [totalPage, setTotalPage] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderBy, setOrderBy] = useState("profileName");
  const [orderDirection, setOrderDirection] = useState(true);
  const marketId = props.marketId
    ? props.marketId
    : null;
  const [campClassificationTable, setCampClassificationTable] = useState({});

  //campClassification analysis table data from props
  useEffect(() => {
    if (props && props.data) {
      setCampClassificationTable(props.data);
    }
  }, [props && props.data]);

  return (
    <div>
      <div >
      <div className="table-legend">
          <span><b>AAA</b> is A + AA + Additional Features</span>
          <span><b>AA</b> is A + Full Hook up</span>
          <span><b>A</b> is partial hook up + Additional features like a picnic table</span>
          <span><b>B</b> is Partial Electric and Partial Water</span>
          <span><b>C</b> is No Hookups</span>
          <span><b>D</b> is Tent camping (No Vehicular access)</span>
        
        </div>
        <div className="camping-spot">
          <Table className="table-design" >
            <TableHead>
              <TableRow>
                <TableCell>
                  {" "}
                  <span
                    className="hover-hand"
                    onClick={() => {
                      setOrderDirection(!orderDirection);
                      setOrderBy("profileName");
                    }}
                  >
                    Campgrounds {orderDirection ? <ArrowDown /> : <ArrowUp />}
                  </span>
                </TableCell>
                <TableCell>Classification</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Proximity (miles)</TableCell>
                <TableCell>URL</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

              {campClassificationTable &&
                campClassificationTable.length > 0 ? (
                  campClassificationTable.map((data) => (
                    <TableRow key={data.profileid}>
                      <TableCell>{data.profilename}</TableCell>
                      {campClassificationList.map((field) => (
                        <TableCell key={field} >
                          {field ==="website" && data[field] ?  
                          <a href={"http://" + data[field]} target="new">  {data[field]} </a> 
                          : field === "address" ? [ data.streetaddress1, data.streetaddress2, data.city, data.statecode, data.zipcode ].filter(Boolean).join(", ") || ""  :
                          data[field] || '-' }
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} style={{ textAlign: "center" }} className="store-no-data">No records found</TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>
        </div>
      </div>

    </div>
  );
});

export default CampClassificationPdf;
